interface DocumentTypeCardProps {
  classification: string;
  documentCount: number;
  onClick: () => void;
}

export function DocumentTypeCard({ classification, documentCount, onClick }: DocumentTypeCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm transition hover:border-gray-300 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-200 dark:hover:border-zinc-600 dark:hover:bg-zinc-700/50"
    >
      <span className="font-medium">{classification}</span>
      <span className="tabular-nums text-gray-400 dark:text-zinc-500">{documentCount}</span>
    </button>
  );
}
